
import { Component, Vue } from "vue-property-decorator";
import NewsPageTep from "@/template/newspage/NewsPageDetail.vue";
@Component
export default class NewsPage extends NewsPageTep {}
